import React, { useState } from 'react';

import List from 'common/components/List';
import Responsive from 'common/components/Responsive';
import moment, { Moment } from 'moment'; // tslint:disable-line:import-blacklist
import { SingleDatePicker } from 'react-dates';

interface Props {
    value: string | null;
    onChange: (date: Moment | null) => void;
}

const TimelineField: React.FunctionComponent<Props> = ({ value, onChange }) => {
    const [hasTimeline, setHasTimeline] = useState(value !== null);
    return (
        <List spacing="small">
            <label className="radio">
                <input
                    className="radio__input"
                    type="radio"
                    checked={hasTimeline}
                    onChange={() => setHasTimeline(true)}
                />
                <span className="radio__text">{__('Yes')}</span>
            </label>
            {hasTimeline && (
                <>
                    <label>{__('Expected completion')}</label>
                    <Responsive min="normal">
                        <SingleDatePicker
                            date={value == null ? value : moment(value)}
                            id="timeline"
                            onFocusChange={() => {}}
                            onDateChange={onChange}
                            focused={hasTimeline}
                            block={true}
                            hideKeyboardShortcutsPanel={true}
                            orientation="horizontal"
                        />
                    </Responsive>
                    <Responsive max="medium">
                        <SingleDatePicker
                            date={value == null ? value : moment(value)}
                            id="timeline"
                            onFocusChange={() => {}}
                            onDateChange={onChange}
                            focused={hasTimeline}
                            block={true}
                            hideKeyboardShortcutsPanel={true}
                            orientation="vertical"
                        />
                    </Responsive>
                </>
            )}
            <label className="radio">
                <input
                    className="radio__input"
                    type="radio"
                    checked={!hasTimeline}
                    onChange={e => {
                        setHasTimeline(false);
                        onChange(null);
                    }}
                />
                <span className="radio__text">{__('No')}</span>
            </label>
        </List>
    );
};

export default TimelineField;
